export var FlowFormV2Mode;
(function (FlowFormV2Mode) {
    FlowFormV2Mode["AddOnly"] = "AddOnly";
    FlowFormV2Mode["AddAndWait"] = "AddAndWait";
    FlowFormV2Mode["AddAndWaitForCompletion"] = "AddAndWaitForCompletion";
})(FlowFormV2Mode || (FlowFormV2Mode = {}));
export function isFlowFormV2WaitMode(mode) {
    return mode === FlowFormV2Mode.AddAndWait || mode === FlowFormV2Mode.AddAndWaitForCompletion;
}
//# sourceMappingURL=v2Mode.js.map